import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  checkTrackerPortfolio,
  getTrackerRevisionStrategies,
} from '../../services/portfolio-tracker/portfolio-tracker-service'
import type { TrackerCheckRequest } from '../types/portfolio-tracker.types'
import type { StrategyDirection } from '../types/trading-strategy.types'

const PORTFOLIO_TRACKER_KEY = ['portfolio-tracker'] as const

export const useTrackerRevisionStrategies = (revisionId: string | undefined, side: StrategyDirection) =>
  useQuery({
    queryKey: [...PORTFOLIO_TRACKER_KEY, 'revisions', revisionId, side],
    queryFn: () => getTrackerRevisionStrategies(revisionId!, side),
    enabled: !!revisionId,
  })

/** Asked again whenever the portfolio changes, keeping the last answer on screen until the next one arrives. */
export const useTrackerCheck = (request: TrackerCheckRequest | null) =>
  useQuery({
    queryKey: [...PORTFOLIO_TRACKER_KEY, 'check', request],
    queryFn: () => checkTrackerPortfolio(request!),
    enabled: !!request,
    placeholderData: keepPreviousData,
  })
